import { Box } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";

import { RoutineOccasionAssignees_RoutineOccasion$key } from "./__generated__/RoutineOccasionAssignees_RoutineOccasion.graphql";
import { ToolbarButtonAssignees } from "widgets/src/Todo/TodoToolbar/ToolbarButtonAssignees";

export function RoutineOccasionAssignees(props: {
  occasion: RoutineOccasionAssignees_RoutineOccasion$key;
  onPress: () => void;
}) {
  const occasion = useFragment(
    graphql`
      fragment RoutineOccasionAssignees_RoutineOccasion on RoutineOccasion {
        id
        assigned {
          employee {
            id
            ...ToolbarButtonAssignees_employees
          }
        }
        assignedRoles {
          role {
            id
            ...ToolbarButtonAssignees_roles
          }
        }
      }
    `,
    props.occasion
  );

  const assignedEmployees = occasion.assigned.flatMap((ae) =>
    ae.employee ? [ae.employee] : []
  );

  const assignedRoles = occasion.assignedRoles.map((ar) => ar.role);

  return (
    <Box
      borderColor="border-primary"
      style={{ borderWidth: 1 }}
      color="surface"
      cornerRadius="large"
    >
      <Box
        style={{ flexDirection: "row", flexWrap: "wrap" }}
        gap="small"
        space="medium"
      >
        <ToolbarButtonAssignees
          assignedEmployees={assignedEmployees}
          assignedRoles={assignedRoles}
          isLocked={false}
          onPress={props.onPress}
        />
      </Box>
    </Box>
  );
}
